import getClientSideQueryParam from "../../../../Utilities/UrlUtilities/getClientSideQueryParam";
import React, { useEffect } from "react";
import { StorageAccessor } from "../../../../Utilities/LocalStorageUtility/LocalStorageUtility";

// required parameters takes an object, the keys are the keys of the URL parameters
// if a value is specified, then that value must match (case insensitive) or we don't capture the parameters
// if the value is set to true, then that key must be present in the URL (or we don't capture the parameters)
// if the value is set to false, then that key is optional and will be captured if all other required parameters are present
export default function SocialMedia({cacheKey, requiredParameters}) {
  
    useEffect(() => {
        try {
            // 30 days 
            const minutes = 43200;
            const obj = {};
            let shouldStoreObject = []; 

            for(let [key, value] of Object.entries(requiredParameters)){ 
                const actualKeyValue = getClientSideQueryParam(key);
                obj[key] = actualKeyValue;  

                if (!value) { // value of false means to try to capture key, but doesn't require it for storage conditions
                    shouldStoreObject.push(true); 
                } else if (actualKeyValue && ((value === true) || (value.toLowerCase() === actualKeyValue.toLowerCase()))) {
                    shouldStoreObject.push(true);
                } else {
                    shouldStoreObject.push(false);
                }
            }

            if(shouldStoreObject.every((e) => e)){
                StorageAccessor.localStorage.setObj(cacheKey, obj, minutes);
            }
            
        } catch (err) {
            console.error("Social media token failed to save");
        }        
    }, []);  

    return false; 
}
  